import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { Listing } from '../../../listing/shared/listing.model';
import { ListingService } from '../../../listing/shared/listing.service';
import { ListingType } from '../../../listing/shared/listing-type.model';
import { ListingCategory } from '../../../listing-catagories/listing-category.model';
import { ListingSubCategory } from '../../../listing-catagories/listing-sub-category.model';
import { ListingSubCategoryService } from '../../../listing-catagories/listing-sub-category.service';
import { ListingPosition } from '../../../listing/shared/listing-position.model';
import { Entity } from 'src/app/entity/shared/entity.model';
import { NotificationService, UtilService } from 'src/app/shared';
import { SelectItem } from 'primeng/api';
import { EntityDomainDto } from '../../../affcode/shared/dto/entity-domain.dto';

@Component({
  selector: 'wl-profile-edit-listing',
  templateUrl: './profile-edit-listing.component.html',
  styleUrls: ['./profile-edit-listing.component.less'],
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditListingComponent),
    CreateObjectValueValidationProvider(ProfileEditListingComponent),
    ListingSubCategoryService,
  ],
  standalone: false
})
export class ProfileEditListingComponent extends ObjectValueAccessor<Listing> implements OnInit, AfterViewInit {
  relatedProfiles: any[] = [];
  relatedProfilesReportNames: any[] = [];
  allSubCategories: Array<ListingSubCategory>;
  mySubCategories: Array<ListingSubCategory>;

  htmlDescr: string;
  @Output() public primaryListingSelected: EventEmitter<Listing> = new EventEmitter<Listing>();
  @Output() public categoryChanged: EventEmitter<Listing> = new EventEmitter<Listing>();
  @Output() public copyListingClicked: EventEmitter<Listing> = new EventEmitter<Listing>();
  @Output() public entityChanged: EventEmitter<Listing> = new EventEmitter<Listing>();
  @Input() relatedProfileSelectItems = new Array<SelectItem>();
  @Input() listingTypes = new Array<ListingType>();
  @Input() categories = new Array<ListingCategory>();
  @Input() listingPositions = new Array<ListingPosition>();
  @Input() tenantHttpsUrl = '';
  @Input() entities = new Array<Entity>();
  @Input() entityDomains = new Array<EntityDomainDto>();

  private _showEditor = false;
  public addressState = '';

  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  public constructor(
    private _listingService: ListingService,
    private _listingSubCategoryService: ListingSubCategoryService,
    private _notificationService: NotificationService,
  ) {
    // Initialize with a real new object instead of just casting {} as Listing
    super(new Listing(), false);
    this.allSubCategories = [];
    this.mySubCategories = [];
  }

  ngOnInit() { }

  ngAfterViewInit() {
    // Set pristine after Angular has initially set the model
    setTimeout(() => {
      if (this.value) {
        this.htmlDescr = this.value.Descr;
        this.addressState = this.value.State;

        if (this.value.CategoryID) {
          this._listingSubCategoryService.getSubCategoriesForCategoryId(this.value.CategoryID).then((data) => {
            this.mySubCategories = data.Result;
          });
        }
        
        if (!this.value.CategorySubCategory) {
          this.emitCategoryChanged();
        }
      }
      this.setPristine();
    });
  }

  save(profileId: number) {
    let promise: Promise<any> = Promise.resolve();

    if (!this.value) {
      return promise;
    }

    this.value.State = this.addressState;

    if (this.value.ListingID) {
      if (this.isDirty()) {
        promise = this._listingService.updateListing(this.value);
      }
    } else if (this.value.CategoryID > 0) {
      // make sure we don't send any listings without categories
      this.value.ProfileID = profileId;
      promise = this._listingService.createListing(this.value).then((data) => {
        this.value.ListingID = data;
      });
    }

    return promise.then(() => this.setPristine());
  }

  onCategoryChange(id: number) {
    if (id) {
      this._listingSubCategoryService.getSubCategoriesForCategoryId(id).then((data) => {
        this.mySubCategories = data.Result;
        this.emitCategoryChanged();
      });
    }
  }

  onEntityChange() {
    this.entityChanged.emit(this.value);
  }

  onSubCategoryChange() {
    this.emitCategoryChanged();
  }

  primaryListingChanged(listing: Listing) {
    if (listing && listing.PrimaryListing) {
      this.primaryListingSelected.emit(listing);
    }
  }

  copyClicked() {
    this.copyListingClicked.emit(this.value);
    this._notificationService.translateSuccess('listing.info-copied');
  }

  private emitCategoryChanged() {
    if (!this.value || !this.value.CategoryID) {
      return;
    }

    const category = this.categories.find((x) => x.CategoryID == this.value.CategoryID)?.Category;
    const subCategory = this.mySubCategories.find(
      (x) => x.SubCategoryID == this.value.SubCategoryID && x.CategoryID == this.value.CategoryID
    )?.SubCategory;

    this.value.CategorySubCategory = [category, subCategory].filter((x) => x).join('/');
    this.categoryChanged.emit(this.value);
  }
}